import Queue from '../asset/Queue';
/* Queue that ensures one file transfer at a time.  */
export var queue = new Queue(1);
queue.start();



//////////////////
// WEBPACK FOOTER
// ./js/services/fileTransferQueue.ts
// module id = null
// module chunks = 